import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSnapchat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 6c.628-.005 1.527.136 2.275.741.708.574 1.237 1.528 1.305 3.045.172-.011.362 0 .54.05a.93.93 0 0 1 .464.287c.132.157.2.358.2.593 0 .49-.288.797-.606.967-.176.093-.368.15-.543.18.08.377.24.838.507 1.23.338.497.828.865 1.539.865.128 0 .243.081.283.201.094.276.012.628-.337.883-.294.216-.77.358-1.486.385-.048.155-.135.32-.278.467-.245.252-.628.422-1.172.422a.3.3 0 0 1-.134-.031c-.1-.05-.475-.131-.85.24-.288.282-.663.448-.976.544A2.8 2.8 0 0 1 12 17.2c-.135 0-.42-.036-.731-.131-.313-.096-.688-.262-.975-.545-.376-.37-.752-.288-.851-.24a.3.3 0 0 1-.134.032c-.544 0-.927-.17-1.172-.422a1.15 1.15 0 0 1-.277-.467c-.718-.027-1.192-.17-1.487-.385-.349-.255-.43-.607-.337-.883a.3.3 0 0 1 .283-.201c.71 0 1.2-.368 1.539-.864.267-.393.428-.854.507-1.23a1.9 1.9 0 0 1-.543-.181c-.318-.17-.606-.477-.606-.967 0-.235.068-.436.2-.593a.93.93 0 0 1 .464-.287c.178-.05.368-.061.54-.05.067-1.515.585-2.47 1.289-3.044.744-.606 1.645-.747 2.291-.742"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoSnapchat;
